import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function PageWrapper({ className, children }) {
  return (
    <div className="flex-1 flex">
      <div
        className={cn(
          'container mx-auto px-4 sm:px-6 md:px-5 flex flex-col flex-grow',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}

PageWrapper.defaultProps = {
  className: '',
};

PageWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default PageWrapper;
